// Web stub for @react-native-async-storage/async-storage (localStorage-backed)
const mem = {}
const ls =
  typeof window !== 'undefined' && window.localStorage
    ? window.localStorage
    : null

const AsyncStorage = {
  getItem: async (k) => (ls ? ls.getItem(k) : k in mem ? mem[k] : null),
  setItem: async (k, v) => {
    if (ls) ls.setItem(k, String(v))
    else mem[k] = String(v)
  },
  removeItem: async (k) => {
    if (ls) ls.removeItem(k)
    else delete mem[k]
  },
  mergeItem: async () => {},
  clear: async () => {
    if (ls) ls.clear()
    else Object.keys(mem).forEach((k) => delete mem[k])
  },
  getAllKeys: async () => (ls ? Object.keys(ls) : Object.keys(mem)),
  multiGet: async (keys) =>
    Promise.all(
      keys.map(async (k) => [k, ls ? ls.getItem(k) : mem[k] ?? null]),
    ),
  multiSet: async (pairs) => {
    pairs.forEach(([k, v]) =>
      ls ? ls.setItem(k, String(v)) : (mem[k] = String(v)),
    )
  },
  multiRemove: async (keys) => {
    keys.forEach((k) => (ls ? ls.removeItem(k) : delete mem[k]))
  },
}

export default AsyncStorage
